var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBold = function SvgBold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 6.34375C9.40625 5.6875 10 4.6875 10 3.5C10 1.59375 8.40625 0 6.5 0H0.25C0.09375 0 0 0.125 0 0.25V0.75C0 0.90625 0.09375 1 0.25 1H1V13H0.25C0.09375 13 0 13.125 0 13.25V13.75C0 13.9062 0.09375 14 0.25 14H7C9.1875 14 11 12.2188 11 10C11 8.375 9.96875 6.9375 8.5625 6.34375ZM2 1H6.5C7.875 1 9 2.125 9 3.5C9 4.90625 7.875 6 6.5 6H2V1ZM7 13H2V7H7C8.625 7 10 8.375 10 10C10 11.6562 8.625 13 7 13Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bold.e1858668.svg";
export { ForwardRef as ReactComponent };